import { React } from "react";
import { LandingPageBanner } from "../../../../containers/LandingPageContainers/LandingPageBanner/LandingPageBanner";
import congratsImage from "../../../../assets/images/cover-images/congrats-img.png";
import "./SignUpVerifiedAccount.css";
// import { Button, Space, Modal } from "antd";
// import { Link } from "react-router-dom";

export const SignUpVerifiedAccount = () => {
     // const [noCloseModal, setNoCloseModal] = useState(false);

     // const handleNoCloseClose = () => {
     //      setNoCloseModal(false);
     // }; 
     
     // const Congratulations = () => {
     //      return (
     //           <Modal
     //                title="Congratulations"
     //                open={noCloseModal}
     //                wrapClassName="mtp-modal no-close"
     //                onCancel={handleNoCloseClose}
     //                width={400}
     //                footer={""}
     //                centered
     //           >

     //                <div className="verified-account-wrap">
     //                     <div className="congrats-image-wrap flex-center flex-center-auto-0">
     //                          <img src={congratsImage} alt="profile-cover" />
     //                     </div>
     //                     <h4 className="fw-600 text-color-alpha ">Congratulations</h4>
     //                     <p className="fw-500 text-color-alpha ">You’ve unlocked your Free Employer Account.</p>
     //                     <span> <Link  className="explore-link-wrap fw-500 "> Let’s Explore </Link></span>
     //                </div>

     //           </Modal>
     //      );
     // };

     return (
          <>
               {/* // _BEGIN > SECTION - CLAIM EMPLOYER PROFILE < RIA // */}
               <LandingPageBanner />
               {/* // _ENDS > SECTION - CLAIM EMPLOYER PROFILE < RIA // */}


               {/* // _BEGIN > SECTION -CONGRATULATION  < RIA // */}
               <section className="verified-account ground-color-ashes">
                    <div className="mtp-container">
                         <div className="verified-account-wrap">
                              <div className="congrats-image-wrap flex-center flex-center-auto-0">
                                   <img src={congratsImage} alt="profile-cover" />
                              </div>
                              <h4 className="fw-600 text-color-alpha ">Congratulations</h4>
                              <span className="fw-500 text-color-alpha ">You’ve unlocked your Free Employer Account.</span>
                         </div>

                         {/* // _BEGIN > CONGRATULATION MODAL  < RIA // */}
                         {/* <Space>
                              <Button className="CustomButton" type="prime-outlined" onClick={() => setNoCloseModal(true)}>
                                   Custom Width Modal
                              </Button>
                         </Space>

                         <Congratulations /> */}

                         {/* // _END > CONGRATULATION MODAL  < RIA // */}
                    </div>
               </section>


               {/* // _ENDS > SECTION -CONGRATULATION < RIA // */}
          </>
     )
}